module.exports = require("core-js/modules/es.array.for-each");